import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import { Table } from 'react-bootstrap'
import styled from 'styled-components'

import Address from '../../../../1stlog-ui/src/components/Address'
import { useField } from '../../../../1stlog-ui/src/components/Field'
import Row from './Row'

const Wrapper = styled.div``

const Readonly = (props) => {
  const { emptyText } = props

  const reference = useField('reference')
  const name1 = useField('name1')
  const name2 = useField('name2')
  const name3 = useField('name3')
  const street = useField('street')
  const streetNumber = useField('streetNumber')
  const streetNumberAddition = useField('streetNumberAddition')
  const city = useField('city')
  const zip = useField('zip')
  const country = useField('country')
  const prename = useField('prename')
  const surname = useField('surname')
  const phone1 = useField('phone1')
  const mail = useField('mail')
  const eori = useField('eori')
  const ustid = useField('ustid')
  const customerAddressHint = useField('customerAddressHint')
  const driverInstructions = useField('driverInstructions')

  const address = {
    reference,
    name1,
    name2,
    name3,
    street,
    streetNumber,
    streetNumberAddition,
    city,
    zip,
    country,
    prename,
    surname,
    phone1,
    mail,
    eori,
    ustid,
    customerAddressHint,
    driverInstructions,
  }

  if (
    lodash.some(
      lodash.map(
        lodash.pick(address, ['name1', 'street', 'city', 'zip']),
        (f) => lodash.isEmpty(f),
      ),
    )
  ) {
    return (
      <div className="text-muted">{emptyText || 'Keine Adresse angegeben'}</div>
    )
  }

  return (
    <Wrapper>
      <Address
        address={address}
        additionalRows={
          <>
            {customerAddressHint && (
              <Row
                label={i18n.t('reference_code', 'Referenzcode')}
                value={customerAddressHint}
              />
            )}
            {driverInstructions && (
              <Row
                label={i18n.t('driver_instructions', 'Fahreranweisungen')}
                value={driverInstructions}
              />
            )}
          </>
        }
      />
    </Wrapper>
  )
}

export default Readonly
